// Error Messages
export const ERROR_GENERIC = "Oops! Something went wrong!";
export const TRANSACTION_TYPE_ERROR_MESSAGE =
  "You must have this document assigned to at least one Property Type under any of the tranasction types";

// MergeFieldCategories
export const MERGEFIELDCATEGORY_LISTING = 1;
export const MERGEFIELDCATEGORY_SALE = 2;
export const MERGEFIELDCATEGORY_RENTAL = 3;
export const MERGEFIELDCATEGORY_OUTSIDEAGENT = 6;
export const MERGEFIELDCATEGORY_AGENT = 7;
export const MERGEFIELDCATEGORY_VENDOR = 8;
export const MERGEFIELDCATEGORY_CLIENT = 9;
export const MERGEFIELDCATEGORY_PROSPECT = 10;

// MailMergeCategory
export const MAILMERGECATEGORY_PROSPECT = 1;
export const MAILMERGECATEGORY_AGENT = 2;
export const MAILMERGECATEGORY_VENDOR = 3;
export const MAILMERGECATEGORY_CLIENT = 4;
export const MAILMERGECATEGORY_LISTING = 5;
export const MAILMERGECATEGORY_SALE = 6;
export const MAILMERGECATEGORY_OUTSIDEAGENT = 7;
export const MAILMERGECATEGORY_RENTAL = 8;

// MailMergeMediaType
export const MAILMERGEMEDIATYPE_EMAIL = 166;
export const MAILMERGEMEDIATYPE_LETTER = 304;
export const MAILMERGEMEDIATYPE_SMS = 167;

// ACTIVITYPLANCATEGORY
export const ACTIVITYPLANCATEGORY_AGENT = 2;
export const ACTIVITYPLANCATEGORY_LISTING = 5;
export const ACTIVITYPLANCATEGORY_RENTAL = 8;
export const ACTIVITYPLANCATEGORY_SALE = 6;

// ACTIVITYPLAN_ADDINGPLAN
export const ACTIVITYPLAN_ADDINGPLAN_ENUM = {
  Sale_AddingPlan: 649,
  Rental_AddingPlan: 652,
  Listing_AddingPlan: 651,
  Agent_AddingPlan: 650,
};

// ACTIVITYPLANAGENTSUBCATEGORY
export const ACTIVITYPLANAGENTSUBCATEGORY_ACTIVE = 327;
export const ACTIVITYPLANAGENTSUBCATEGORY_SEVERED = 328;

// ACTIVITYPLANEXECUTIONTYPE
export const ACTIVITYPLANEXECUTIONTYPE_PERFORMEVENT = 282;
export const ACTIVITYPLANEXECUTIONTYPE_AFTERPRECEDING = 283;
export const ACTIVITYPLANEXECUTIONTYPE_PERFORMIMMEDIATELY = 329;

// Alert keys
export const ALERT_SERVER_ERROR = "serverError";

export const ALERT_NOTE_SAVE = "noteSave";
export const ALERT_NOTE_FAIL = "noteFail";
export const ALERT_NOTE_DELETE = "noteDelete";

export const ALERT_FRANCHISE_DELETE = "franchiseDelete";
export const ALERT_FRANCHISE_SAVE = "franchises_ave";
export const ALERT_FRANCHISE_FAIL = "franchiseFail";

export const ALERT_OFFICE_SAVE = "officeSave";
export const ALERT_OFFICE_FAIL = "officeFail";
export const ALERT_OFFICE_DELETE = "officeDelete";

export const ALERT_MLSPROVIDER_SAVE = "mlsProviderPlanSave";
export const ALERT_MLSPROVIDER_FAIL = "mlsProviderPlanFail";
export const ALERT_MLSPROVIDER_DELETE = "mlsProviderDelete";

export const ALERT_REALESTATEBOARD_SAVE = "realEstateBoardSave";
export const ALERT_REALESTATEBOARD_FAIL = "realEstateBoardFail";
export const ALERT_REALESTATEBOARD_DELETE = "realEstateBoardDelete";

export const ALERT_EMAIL_SAVE = "emailSave";
export const ALERT_EMAIL_FAIL = "emailFail";
export const ALERT_EMAIL_DELETE = "emailDelete";

export const ALERT_PHONENUMBER_SAVE = "phoneNumberSave";
export const ALERT_PHONENUMBER_FAIL = "phoneNumberFail";
export const ALERT_PHONENUMBER_DELETE = "phoneNumberDelete";

export const ALERT_COMMISSIONPLAN_SAVE = "commissionPlanSave";
export const ALERT_COMMISSIONPLAN_FAIL = "commissionPlanFail";
export const ALERT_COMMISSIONPLAN_DELETE = "commissionPlanDelete";

export const ALERT_COMMISSIONPLANFEE_DELETE = "commissionPlanFeeDelete";

export const ALERT_FRANCHISEPRODUCT_SAVE = "franchiseProductSave";
export const ALERT_FRANCHISEPRODUCT_FAIL = "franchiseProductFail";
export const ALERT_FRANCHISEPRODUCT_DELETE = "franchiseProductDelete";

export const ALERT_PRODUCT_DELETE = "productDelete";

export const ALERT_TERRITORY_SAVE = "territorySave";
export const ALERT_TERRITORY_FAIL = "territoryFail";
export const ALERT_TERRITORY_DELETE = "territoryDelete";

// Page types
export const COMP_TYPE_FRANCHISE = "franchise";
export const COMP_TYPE_OFFICE = "office";
export const COMP_TYPE_MLSPROVIDER = "mlsProvider";
export const COMP_TYPE_TERRITORY = "territory";
export const COMP_TYPE_ROYALTYPLAN = "royaltyPlan";
export const COMP_TYPE_MARKETINGAREA = "marketingArea";

// Alert types
export const ALERT_TYPE_INFO = "info";
export const ALERT_TYPE_DANGER = "danger";

// Async States
export const STATE_AUTHENTICATING = "authenticating";
export const STATE_PROCESSING = "processing";
export const STATE_FAIL = "fail";
export const STATE_SUCCESS = "success";
export const STATE_RESET = "reset";

// Territory Types
export const TERRITORY_TYPE_FRANCHISE = "Franchise";
export const TERRITORY_TYPE_MARKETING = "Marketing";
export const TERRITORY_TYPE_ROFR = "ROFR";

export const DOCUMENT_CATEGORY_ENUM = {
  Transaction: 127,
  AgentOrProspect: 128,
};

export const DOCUMENT_CATEGORY = {
  Transaction: "transaction",
  AgentOrProspect: "agentOrProspect",
};

export const DOCUMENT_EDIT_SETUP = {
  Info: "info",
  Source: "source",
  Pages: "pages",
  Mapping: "mapping",
};

export const TRANSACTION_TYPE_COLUMN_ENUM = {
  Type: 1,
  IsSelected: 2,
  IsRequiredForSeller: 3,
  IsRequiredForBuyer: 4,
  IsReview: 5,
  IsRequiredForCombined: 6,
  IsRequiredForPayment: 7,
  IsFineEligible: 8,
};

export const TRANSACTION_TYPE_ENUM = {
  Listing: 1,
  Sale: 2,
  Rental: 3,
  Referral: 4,
  BuyerBroker: 5,
};

export const DOCUMENT_TYPE_ENUM = {
  MlsProvider: 244,
  Association: 245,
  PurchaseContract: 241,
  SellerCounterOffer: 240,
  BuyerCounterOffer: 239,
};

export const DOCUMENT_TYPES_BY_ID = {
  244: "MLS Provider",
  245: "Association",
  241: "Purchase Contract",
  240: "Seller Counter Offer",
  239: "Buyer Counter Offer",
};

export const DOCUMENT_STATUS_ENUM = {
  Active: 1,
  InActive: 2,
};

export const DEFAULT_STATUS_KEY = "1";
export const DEFAULT_FRANCHISE_TAB = "general";
export const FRANCHISE_FORM_BUILDR_TAB_KEY = "form-builder";
export const STATUS_OPTIONS = [
  {
    id: "1",
    name: "Active",
  },
  {
    id: "2",
    name: "Inactive",
  },
];

export const DEFAULT_PERCENTAGE_OF_ID = 182;
export const DEFAULT_DECIMAL_VALUE = 0.0;
export const MIN_PERCENTAGE_VALUE = 0.0001;
export const MAX_PERCENTAGE_VALUE = 100;

export const FEATURE_FLAG_ENUM = {
  NetSuiteIntegration: 19,
  FormBuider: 31,
  GoogleGroupManagement: 44,
  BuyerBroker: 55,
  FineEligibility: 76
};

export const PAYMENT_SUBSCRIPTION_CATEGORY_ENUM = {
  MLSFees: 4,
  BoardDues: 7,
};

export const PERMISSION_DASHBOARD = "dashboard";
export const PERMISSION_DASHBOARD_EXPIRINGFRANCHISES =
  "dashboard_expiringfranchises";
export const PERMISSION_DASHBOARD_AGENTTRANSACTIONS =
  "dashboard_agenttransactions";
export const PERMISSION_DASHBOARD_CENTRALIZEDSERVICES =
  "dashboard_centralizedservices";

export const PERMISSION_FRANCHISES = "franchises";
export const PERMISSION_FRANCHISES_GENERAL = "franchises_general";
export const PERMISSION_FRANCHISES_OFFICES = "franchises_offices";
export const PERMISSION_FRANCHISES_OFFICES_GENERALINFO =
  "franchises_offices_generalinfo";
export const PERMISSION_FRANCHISES_OFFICES_MLSPROVIDERS =
  "franchises_offices_mlsproviders";
export const PERMISSION_FRANCHISES_OFFICES_TERRITORIES =
  "franchises_offices_territories";
export const PERMISSION_FRANCHISES_OFFICES_NOTES = "franchises_offices_notes";
export const PERMISSION_FRANCHISES_AGENTFEES = "franchises_agentfees";
export const PERMISSION_FRANCHISES_COMMISSIONS = "franchises_commissions";
export const PERMISSION_FRANCHISES_COMMISSIONS_COMMISSIONPLANS =
  "franchises_commissions_commissionplans";
export const PERMISSION_FRANCHISES_COMMISSIONS_WAITINGPERIODS =
  "franchises_commissions_waitingperiods";
export const PERMISSION_FRANCHISES_COMMISSIONS_PROMOTIONS =
  "franchises_commissions_promotions";
export const PERMISSION_FRANCHISES_COMMISSIONS_TRANSACTIONFEES =
  "franchises_commissions_transactionfees";
export const PERMISSION_FRANCHISES_ROYALTYPLANS = "franchises_royaltyplans";
export const PERMISSION_FRANCHISES_ROYALTYPLANS_ROYALTYPLANINFO =
  "franchises_royaltyplans_royaltyplaninfo";
export const PERMISSION_FRANCHISES_ROYALTYPLANS_AGENTFEES =
  "franchises_royaltyplans_agentfees";
export const PERMISSION_FRANCHISES_ROYALTYPLANS_OTHERRECURRINGFEES =
  "franchises_royaltyplans_otherrecurringfees";
export const PERMISSION_FRANCHISES_ROYALTYPLANS_NOTES =
  "franchises_royaltyplans_notes";
export const PERMISSION_FRANCHISES_PRODUCTS = "franchises_products";
export const PERMISSION_FRANCHISES_REALESTATE = "franchises_realestate";
export const PERMISSION_FRANCHISES_REALESTATE_MEMBERSHIPS =
  "franchises_realestate_memberships";
export const PERMISSION_FRANCHISES_REALESTATE_MLS = "franchises_realestate_mls";
export const PERMISSION_FRANCHISES_REALESTATE_DOCUMENTSETUP =
  "franchises_realestate_documentsetup";
export const PERMISSION_FRANCHISES_REALESTATE_DOCUMENTSETUP_TRANSACTIONS =
  "franchises_realestate_documentsetup_transactions";
export const PERMISSION_FRANCHISES_REALESTATE_DOCUMENTSETUP_AGENTSPROSPECTS =
  "franchises_realestate_documentsetup_agentsprospects";
export const PERMISSION_FRANCHISES_SUPPORT = "franchises_support";
export const PERMISSION_FRANCHISES_SUPPORT_LEDGER = "franchises_support_ledger";
export const PERMISSION_FRANCHISES_SUPPORT_TERRITIORIES =
  "franchises_support_territories";
export const PERMISSION_FRANCHISES_SUPPORT_STAFF = "franchises_support_staff";
export const PERMISSION_FRANCHISES_SUPPORT_FILES = "franchises_support_files";
export const PERMISSION_FRANCHISES_SUPPORT_DISCLAIMERS =
  "franchises_support_disclaimers";
export const PERMISSION_FRANCHISES_SUPPORT_NOTES = "franchises_support_notes";
export const PERMISSION_FRANCHISES_RSASETTINGS = "franchises_rsasettings";

export const PERMISSION_SETTINGS = "settings";
export const PERMISSION_SETTINGS_FINES = "settings_fines";
export const PERMISSION_SETTINGS_MLSPROVIDERS = "settings_mlsproviders";
export const PERMISSION_SETTINGS_MLSPROVIDERS_GENERAL =
  "settings_mlsproviders_general";
export const PERMISSION_SETTINGS_MLSPROVIDERS_FRANCHISES =
  "settings_mlsproviders_franchises";
export const PERMISSION_SETTINGS_MLSPROVIDERS_FILES =
  "settings_mlsproviders_files";
export const PERMISSION_SETTINGS_MLSPROVIDERS_NOTES =
  "settings_mlsproviders_notes";
export const PERMISSION_SETTINGS_REALESTATEBOARDS = "settings_realestateboards";
export const PERMISSION_SETTINGS_DEPARTMENTOFREALESTATE = "settings_departmentofrealestate";
export const PERMISSION_SETTINGS_ROYALTYPLANS = "settings_royaltyplans";
export const PERMISSION_SETTINGS_ROYALTYPLANS_ROYALTYPLANINFO =
  "settings_royaltyplans_royaltyplaninfo";
export const PERMISSION_SETTINGS_ROYALTYPLANS_ROYALTYPLANINFO_SALEFEE =
  "settings_royaltyplans_royaltyplaninfo_salefee";
export const PERMISSION_SETTINGS_ROYALTYPLANS_ROYALTYPLANINFO_RENTALFEE =
  "settings_royaltyplans_royaltyplaninfo_rentalfee";
export const PERMISSION_SETTINGS_ROYALTYPLANS_ROYALTYPLANINFO_REFERRALFEE =
  "settings_royaltyplans_royaltyplaninfo_referralfee";
export const PERMISSION_SETTINGS_ROYALTYPLANS_AGENTFEES =
  "settings_royaltyplans_agentfees";
export const PERMISSION_SETTINGS_ROYALTYPLANS_OTHERRECURRINGFEES =
  "settings_royaltyplans_otherrecurringfees";
export const PERMISSION_SETTINGS_ROYALTYPLANS_NOTES =
  "settings_royaltyplans_notes";
export const PERMISSION_SETTINGS_FEATURES = "settings_features";
export const PERMISSION_SETTINGS_USERMANAGEMENT = "settings_usermanagement";
export const PERMISSION_SETTINGS_FRANCHISEROLEMANAGEMENT =
  "settings_franchiserolemanagement";
export const PERMISSION_SETTINGS_RSA_MENU_SETTINGS = "settings_rsasettings";
export const PERMISSION_SETTINGS_GLOBALSETTINGS = "settings_globalsettings";
export const PERMISSION_SETTINGS_GmailGroups = "settings_gmailgroups";

export const PERMISSION_CLASSES = "classes";

export const PERMISSION_CONTRACTS = "contracts";

export const PERMISSION_CONTENT = "content";
export const PERMISSION_CONTENT_POPUPNOTICES = "content_popupnotices";
export const PERMISSION_CONTENT_COMPANYNEWS = "content_companynews";
export const PERMISSION_CONTENT_COMMUNICATIONGROUPS = "content_communicationgroups";
export const PERMISSION_CONTENT_DOCUMENTS = "content_documents";
export const PERMISSION_CONTENT_FAQCATEGORIES = "content_faqcategories";
export const PERMISSION_CONTENT_DOWNLOADS = "content_downloads";
export const PERMISSION_CONTENT_FAQQUESTIONS = "content_faqquestions";
export const PERMISSION_CONTENT_MAILMERGETEMPLATES =
  "content_mailmergetemplates";
export const PERMISSION_CONTENT_MASTERBLASTER = "content_masterblaster";
export const PERMISSION_CONTENT_ACTIVITYPLANS = "content_activityplans";
export const PERMISSION_CONTENT_ACTIVITYPLANS_ACTIVITYPLAN =
  "content_activityplans";
export const PERMISSION_CONTENT_ACTIVITYPLANS_ACTIVITYPLAN_ACTIVITYTEMPLATE =
  "content_activityplans";
export const PERMISSION_CONTENT_SMARTDOCS_MAPPING = "content_smartdocsmapping";
export const PERMISSION_CONTENT_VIDEOCOURSES = "content_videocourses";
export const PERMISSION_CONTENT_SURVEYTEMPLATES = "content_surveytemplates";

export const PERMISSION_REPORTS = "reports";
export const PERMISSION_REPORTS_VIEWREPORTS = "reports_viewreports";
export const PERMISSION_REPORTS_MANAGEREPORTS = "reports_managereports";
export const PERMISSION_REPORTS_MANAGEREPORTS_GENERALINFO =
  "reports_managereports_generalinfo";
export const PERMISSION_REPORTS_MANAGEREPORTS_APPLICATIONS =
  "reports_managereports_applications";
export const PERMISSION_REPORTS_MANAGEREPORTS_FRANCHISES =
  "reports_managereports_franchises";
export const PERMISSION_REPORTS_BROKERMETRICS = "reports_brokermetrics";
export const PERMISSION_REPORTS_AGENTLISTEXPORT = "reports_agentlistexport";
export const PERMISSION_REPORTS_SIDESVOLUMEEXPORT =
  "reports_sidesandvolumeexport";
export const PERMISSION_REPORTS_TRANSACTIONDETAILS =
  "reports_instancetransactiondetails";

export const PERMISSION_TERRITORYMAP = "territorymap";

export const PERMISSION_ACCOUNTING = "accounting";
export const PERMISSION_ACCOUNTING_BALENCEDUEUPLOAD =
  "accounting_balancedueupload";
export const PERMISSION_ACCOUNTING_FRANCHISEPRODUCTS =
  "accounting_franchiseproducts";

export const PERMISSION_MARKETPLACE = "marketplace";
export const PERMISSION_MARKETPLACE_VENDORS = "marketplace_vendors";
export const PERMISSION_MARKETPLACE_VENDORS_GENERAL =
  "marketplace_vendors_general";
export const PERMISSION_MARKETPLACE_VENDORS_DEALS = "marketplace_vendors_deals";
export const PERMISSION_MARKETPLACE_VENDORS_ASSETS =
  "marketplace_vendors_assets";
export const PERMISSION_MARKETPLACE_VENDORS_FRANCHISES =
  "marketplace_vendors_franchises";
export const PERMISSION_MARKETPLACE_CATEGORIES = "marketplace_categories";

export const STATUS_ENUM = {
  Active: 1,
  Inactive: 2,
};

export const RENTAL_PROPERTY_TYPE_ENUM = {
  ResidentialRental: 11,
  CommercialRental: 14,
};

export const INSTANCE_TYPE = {
  Corporate: 485,
  NonCorporate: 486,
  BrokerOps: 487,
};

export const FranchiseNewsTempType = {
  Corporate: -1,
  NonCorporate: -2,
};

export const FranchiseNewsTypeEnum = {
  Corporate: 66,
  NonCorporate: 67,
};

export const FranchiseInstancesType = {
  All: 0,
  Corporate: -1,
  NonCorporate: -2,
  BrokerOps: -3,
};

export const AnnouncementsInstancesTypeEnum = {
  All: 65,
  Corporate: 66,
  NonCorporate: 67,
  BrokerOps: 509,
};

export const EscalationTypeEnum = {
  Monthly: 430,
  Yearly: 431,
  Never: 432
};

export const SurveyQuestionAnswerTypeEnum = {
  Textbox: 386,
  MultipleChoice: 387,
  YesNo: 388,
  StarRating: 389,
};

export const SurveyOtherOptionDisplayTypeEnum = {
  Choice: 390,
  Comment: 391,
};

export const SurveyMultipleChoiceTypeEnum = {
  Single: 403,
  Multiselect: 404,
};

export const DepartmentEmailActivityTargetTypeEnum = {
  AgentServicesDepartmentEmail: 590,
  BillingDepartmentEmail: 591,
  BrokerDepartmentEmail: 592,
  CareerServicesDepartmentEmail: 593,
  ClosingDeptEmail: 594,
  EducationDepartmentEmail: 595,
  OnboardingDepartmentEmail: 596,
  PaperworkDepartmentEmail: 597,
  ReceptionDepartmentEmail: 598,
  MentorshipDepartmentEmail: 599,
};

export const EnvironmentConfig = {
  qa: {
    oidcRedirectUri: process.env.REACT_APP_PROJECT_URL_QA,
    apiLogoutUri: process.env.REACT_APP_WEBAPI_BASE,
  },
  staging: {
    oidcAuthority: process.env.REACT_APP_OIDC_AUTHORITY_STAGING,
    oidcRedirectUri: process.env.REACT_APP_PROJECT_URL_STAGING,
    apiLogoutUri: process.env.REACT_APP_WEBAPI_STAGING,
  },
  production: {
    oidcAuthority: process.env.REACT_APP_OIDC_AUTHORITY_PRODUCTION,
    oidcRedirectUri: process.env.REACT_APP_PROJECT_URL_PRODUCTION,
    apiLogoutUri: process.env.REACT_APP_WEBAPI_PRODUCTION,
  },
  test: {
    oidcRedirectUri: process.env.REACT_APP_PROJECT_URL_TEST,
    apiLogoutUri: process.env.REACT_APP_WEBAPI_TEST,
  },
};
